module.exports = __webpack_public_path__ + "img/loading.7d26db10.svg";